export const version = "address/5.8.0";
//# sourceMappingURL=_version.js.map